import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import type {
    PsHttp,
    PatSnapSuccessResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { DesignFtoApi, GeneralFileUploadResponse, DesignFtoSearchConditions, DesignFtoBatchTaskResponse } from './design-fto-api';
import type { PsHttpChannel } from '@patsnap/tahiti-core';
import { getDesignFtoApiUrlPrefix } from '../constants/design-fto';
import { getCoreTelecomApiUrlPrefix } from '../../common/constants';

@injectable()
export class DesignFtoApiImpl extends PsHttpService implements DesignFtoApi {
    _coreTelecomApiUrlPrefix = '';

    constructor(httpClient: PsHttp, httpChannelClient: PsHttpChannel) {
        super(httpClient, httpChannelClient);
        this.init();
    }

    async init() {
        this._coreTelecomApiUrlPrefix = await getDesignFtoApiUrlPrefix();
    }

    get options() {
        return {
            baseURL: this._coreTelecomApiUrlPrefix,
            headers: {
                'Content-Type': 'application/json',
            },
        };
    }

    /**
     * 上传文件
     */
    async uploadFile(file: File, onProgress?: (e: any) => void) {
        const baseUrl = await getCoreTelecomApiUrlPrefix();
        const formData = new FormData();

        // 添加文件
        formData.append('file', file);

        // 添加可选参数
        formData.append('folder_path', 'eureka-ip/user-upload');
        formData.append('file_prefix', 'design_fto_user_upload');
        formData.append('keep_original_name', String(false));

        const result = await this.post<PatSnapSuccessResponseData<GeneralFileUploadResponse>>({
            baseURL: baseUrl,
            url: '/file-upload/single',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: onProgress,
        });

        const res = result.data;

        return res?.uploaded_files?.[0];
    }

    /**
     * 提交批量任务
     * @param images - 图片列表（1-100个）
     */
    async submitBatchTask(images: DesignFtoSearchConditions[]): Promise<DesignFtoBatchTaskResponse> {
        const result = await this.post<PatSnapSuccessResponseData<any>>({
            url: '/batch/submit',
            data: {
                images,
            },
        });

        return result.data as DesignFtoBatchTaskResponse;
    }
}
